import Phaser from 'phaser';
import { COLORS } from './config';
import { GameScene } from './scenes/GameScene';
import { HomeScene } from './scenes/HomeScene';
import { PasswordScene } from './scenes/PasswordScene';
import { getCustomLevelFromURL } from './utils/levelEncoder';

// Check for custom level in URL
const customLevel = getCustomLevelFromURL();
const hasCustomLevel = !!customLevel;
if (customLevel) {
  (window as any).__customLevel = customLevel;
}

// If custom level in URL, skip home screen and go straight to game
const scenes = hasCustomLevel ? [GameScene, HomeScene, PasswordScene] : [HomeScene, PasswordScene, GameScene];

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: 1024,
  height: 768,
  backgroundColor: COLORS.background,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: scenes,
};

new Phaser.Game(config);
